module.exports = __webpack_public_path__ + "static/media/es.342d52e1.png";